const stringify = require('./stringify');
const { initSendPost } = require('./common');
const logquery  = require('./logquery');

initSendPost(function sendPost(data = {}) {
  logquery.handlerError(data)
});

module.exports = require('./common');
